module.exports = __webpack_public_path__ + "static/media/icon-hide.1a1fc8a4.png";